/**  显示版本号  */
import Vue from 'vue'
import ShowVersion from './ShowVersion.vue'
const ShowVersionCreater = Vue.extend(ShowVersion)
let showVersionInstance

export default {
  open (content, version, time) {
    if (!showVersionInstance) {
      showVersionInstance = new ShowVersionCreater({
        el: document.createElement('div')
      })
      document.body.appendChild(showVersionInstance.$el)
    }
    showVersionInstance.$data.content = content
    showVersionInstance.$data.version = version
    showVersionInstance.$data.time = time
    showVersionInstance.visible = true
  }
}